var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3967 0.149894C15.565 0.298192 15.6365 0.527947 15.5821 0.745531L12.3821 13.5455C12.3296 13.7552 12.1685 13.9205 11.9601 13.9782C11.7518 14.0359 11.5286 13.9771 11.3757 13.8243L7.86491 10.3134L5.87999 12.96C5.74609 13.1385 5.52417 13.228 5.30388 13.1922C5.0836 13.1565 4.90136 13.0014 4.83078 12.7897L3.30938 8.22551L0.331675 6.73665C0.119409 6.63052 -0.010354 6.40925 0.000648507 6.17218C0.0116511 5.93512 0.161351 5.72681 0.382535 5.6408L14.7825 0.0408077C14.9915 -0.0404816 15.2285 0.00159644 15.3967 0.149894ZM8.23157 8.98305C8.22713 8.97847 8.2226 8.97394 8.21799 8.96947L7.84852 8.6L10.6242 5.82426C10.8586 5.58995 10.8586 5.21005 10.6242 4.97574C10.3899 4.74142 10.01 4.74142 9.77572 4.97574L6.57573 8.17573C6.34141 8.41005 6.34141 8.78994 6.57573 9.02426L7.00776 9.4563L5.60708 11.3239L4.36921 7.61026C4.31888 7.4593 4.21065 7.33451 4.06832 7.26334L2.07892 6.26864L14.1366 1.57953L11.4749 12.2264L8.23157 8.98305Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramWhite);
export default __webpack_public_path__ + "static/media/telegram_white.e9e85f49d8d64298acad0257acc26df9.svg";
export { ForwardRef as ReactComponent };